<template>
	<v-layout wrap>
		<v-flex
			xs4
			v-for="(item, i) in $store.state.reservedayInputBox.categories"
			:class="
				$route.path.indexOf('COUNSELORPAGE') > -1 || $route.path.indexOf('sample') > -1
					? 'viewport-item-counselor pr-8'
					: 'viewport-item pr-8'
			"
			:key="i"
		>
			<!-- class="viewport-item" -->
			<div v-if="item.tag === 'location'" :class="nowWidth > 320 ? 'item-style' : 'item-style4'">
				<p class="surveyName">{{ i + 1 }}. {{ item.contents }}</p>
				<pre class="visitexplain">{{ item.explain }}</pre>
				<v-divider class="my-2"></v-divider>
				<div class="mt-2">
					<select-box :sel="$store.state.searchsel_city1" @change="loc_firstSelect"></select-box>
				</div>
				<div>
					<select-box
						:sel="$store.state.searchsel_city2"
						:disabled="$store.state.searchsel_city2.disabled"
						@change="loc_twoSelect"
					></select-box>
				</div>
				<div>
					<select-box :sel="$store.state.searchsel_city3" :disabled="$store.state.searchsel_city3.disabled"></select-box>
				</div>
			</div>
			<div v-else-if="item.type === 10" :class="nowWidth > 320 ? 'item-style' : 'item-style4'">
				<p class="surveyName">{{ i + 1 }}. {{ item.contents }}</p>
				<pre class="visitexplain">{{ item.explain }}</pre>
				<v-divider class="my-2"></v-divider>
				<v-radio-group
					v-model="item.value"
					hideDetails
					class="mt-1"
					@change="setRadioValue(i)"
					:row="$route.path.indexOf('COUNSELORPAGE') > -1 || $route.path.indexOf('sample') > -1"
				>
					<div v-for="(option, i) in item.category_details" :key="i" class="mb-2">
						<v-layout>
							<v-radio
								:label="option.detailname"
								:value="option.detailcode"
								class="mt-2"
								:ripple="false"
								:color="$store.state.PointColor1"
							></v-radio>
							<div v-if="option.detailname === '기타'">
								<txtField v-model="item.etc" :txtField="item.items" class="mb-1 focusColor" />
							</div>
						</v-layout>
					</div>
				</v-radio-group>
			</div>
			<div v-else-if="item.type === 11" class="item-style">
				<p class="surveyName">{{ i + 1 }}. {{ item.contents }}</p>
				<pre class="visitexplain">{{ item.explain }}</pre>
				<div class="checkbox-frame">
					<v-divider class="mt-2"></v-divider>
					<v-layout wrap>
						<v-flex xs12 v-for="(detail, i) in item.category_details" :key="i">
							<checkBoxIcon :check="item.items[i]" :color="$store.state.PointColor1" style="border-bottom:1px;" class="mr-3" />
						</v-flex>
					</v-layout>
				</div>
			</div>
			<div v-else-if="item.type === 12" class="item-style">
				<p class="surveyName">{{ i + 1 }}. {{ item.contents }}</p>
				<pre class="visitexplain">{{ item.explain }}</pre>
				<v-divider class="mt-2"></v-divider>
				<div>
					<selectBox4 :sel="item.items" :items="item.category_details" @change="changeSelected" class="mt-5 mb-5 focusColor" />
				</div>
			</div>
			<div v-else-if="item.type === 20" :class="nowWidth > 320 ? 'item-style' : 'item-style4'">
				<p class="surveyName">{{ i + 1 }}. {{ item.contents }}</p>
				<pre class="visitexplain">{{ item.explain }}</pre>
				<v-divider class="mt-2"></v-divider>
				<txtField v-model="item.items.value" :txtField="item.items" class="mt-5 focusColor" />
			</div>
			<!-- <div v-else-if="item.type === 21" class="fileMargin"> -->
			<div
				v-else-if="item.type === 21"
				:class="
					$route.path.indexOf('COUNSELORPAGE') > -1 || $route.path.indexOf('sample') > -1
						? ['uploadMargin', 'minmax-width320']
						: ['uploadMargin']
				"
			>
				<p class="surveyName">{{ i + 1 }}. {{ item.contents }}</p>
				<pre class="visitexplain">{{ item.explain }}</pre>
				<!-- <v-btn color="#FDC85A">파일추가</v-btn> -->
				<v-divider class="mt-2 mb-3"></v-divider>
				<upload-images
					v-if="$route.path.indexOf('COUNSELORPAGE') > -1 || $route.path.indexOf('sample') > -1"
					:uploadMsg="uploadImagesOptions.uploadMsg"
					clearAll=" "
					class="mb-2"
					@changed="handleImages"
					:class="nowWidth > 600 ? ['imgUploads2', 'direction-row'] : ['imgUploads2', 'direction-column']"
				/>
				<upload-images
					v-else
					:uploadMsg="uploadImagesOptions.uploadMsg"
					clearAll=" "
					class="mb-2"
					@changed="handleImages"
					:class="nowWidth > 600 ? ['imgUploads', 'direction-row'] : ['imgUploads', 'direction-column']"
				/>
				<input id="uploadBtn" style="display:none;" type="file" accept="image/*" @change="uploadMultiple($event)" multiple />
				<div class="surveyName">
					업로드 된 이미지:
				</div>
				<div v-for="(a, idx) in $store.state.reserveusersData.fileUpload" :key="idx">
					<span class="visitexplain" @click="imgdialog(idx)">
						{{ a.name }}
					</span>
					<v-icon v-if="$route.path.split('/')[1] !== 'COUNSELORPAGE'" @click="userimgdelete(idx)">mdi-close</v-icon>
				</div>
			</div>
			<div v-else-if="item.type === 30" :class="nowWidth > 320 ? 'item-style2' : 'item-style4'">
				<!-- <p class="dateGuideDay">방문하시고자 하는 날짜를 선택해 주시기 바랍니다</p> -->
				<div>
					<p class="surveyName">날짜선택 <span class="required-red-dot">*</span></p>
					<v-divider></v-divider>
					{{ item.items }}
					<v-date-picker
						color="#fdc85a"
						locale="ko-kr"
						v-model="picker.date"
						no-title
						:min="$store.state.startDate"
						:max="$store.state.endDate"
						:allowed-dates="allowedDates"
						@change="changePicker"
					>
					</v-date-picker>
					<v-img src="/image/calenderImg.jpg"></v-img>
					<v-divider></v-divider>
					<p class="selectedResVisit mt-5">
						선택하신 날짜는
						<span v-if="picker.date !== ''">{{ picker.date | moment('YYYY년 MM월 DD일') }} {{ $store.state.selectedTime }}</span>
						입니다.
					</p>
					<!-- <p class="selectedRes mb-5">방문하시고자 하는 시간을 선택해주시기 바랍니다</p> -->
				</div>
			</div>
			<div v-else-if="item.type === 31" class="item-style">
				<p class="surveyName">시간선택 <span class="required-red-dot">*</span></p>
				<v-divider></v-divider>
				<v-layout flex-wrap style="max-width:320px;">
					<v-flex xs3 v-for="(time, i) in timeData" :key="i">
						<v-btn
							width="100%"
							:disabled="time.disable"
							elevation="0"
							:color="time.active || $store.state.selectedTime === time.time ? 'grey lighten-2' : 'white'"
							@click="clickTime(time)"
							class="rounded-0 surveyName"
						>
							{{ time.time }}
						</v-btn>
					</v-flex>
				</v-layout>
				<v-divider></v-divider>
				<p class="selectedResVisit mt-5">
					선택하신 날짜는
					<span v-if="picker.date !== ''">{{ picker.date | moment('YYYY년 MM월 DD일') }} {{ $store.state.selectedTime }}</span>
					입니다.
				</p>
			</div>
			<div v-else-if="item.type === 90">
				<termsAgree :groupcode="$route.params.groupcode" :urlInfo="$route.path" style="margin-bottom: 20px;" />
			</div>
		</v-flex>
		<alertModal2 :setdialog="alertModal" />
		<v-dialog v-model="imgfile.dialog" max-width="420" v-if="$store.state.reserveusersData">
			<v-card class="dialog">
				<v-card-title class="title" :style="`background-color:${$store.state.PointColor1}`">
					<h2>
						{{ imgfile.img.name }}
					</h2>
					<v-spacer />
					<v-icon @click="imgfile.dialog = false" class="title-icon" large>mdi-close</v-icon>
				</v-card-title>
				<div class="dialog-content">
					<v-img contain max-width="420" :src="$store.state.backServer + imgfile.img.url"></v-img>
				</div>
			</v-card>
		</v-dialog>
	</v-layout>
</template>

<script>
import { checkBoxIcon, selectBox, selectBox4, termsAgree, txtField } from '@/components/index.js'
import uploadImages from 'vue-upload-drop-images' // 파일 업로드 패키지
import location1 from '../../utils/location1'
import location2 from '../../utils/location2'
import times from '../../utils/times.js'
import alertModal2 from './alertModal2'
export default {
	components: {
		selectBox,
		checkBoxIcon,
		txtField,
		selectBox4,
		termsAgree,
		uploadImages,
		alertModal2,
	},
	data() {
		return {
			doneBtn: {
				class: 'saveBtn',
				block: true,
			},
			alertModal: {
				text: '',
				dialog: false,
			},
			uploadImagesOptions: {
				max: 3,
				uploadMsg: '이미지를 등록해주세요.',
				classOn: false,
			}, // 이미지 업로드 옵션
			viewportList: [],
			// viewport 옵션들
			radioSelected: '',
			txt: {
				value: '',
				maxlength: '255',
				outlined: true,
				autofocus: false,
				hideDetail: false,
				errorMessage: '',
			},
			timeData: [], // 시간 데이터 관련
			selOptions: { label: '', value: '', errorMessage: '', hideDetail: true, outlined: true }, // viewport 셀렉트 박스 옵션
			datetimeArray: [],
			screenWidth: '',

			imgfile: {
				dialog: false,
				img: [],
			},
			nowRadioValue: '', // 현재 라디오버튼 value 임시 저장
		}
	},
	created() {
		this.timeSet()
		setTimeout(() => {
			// this.checkboxIcon()
		}, 500)
		this.$store.state.searchsel_city2.items = location1['서울특별시'].sort()
		this.$store.state.searchsel_city3.items = location2['서울특별시']['강남구'].sort()
		this.screenWidth = window.innerWidth
	},
	computed: {
		picker: {
			get() {
				return this.$store.state.picker
			},
			set(value) {
				this.$store.commit('picker', value)
			},
		},
		nowWidth() {
			window.addEventListener('resize', () => {
				this.screenWidth = window.innerWidth
			})
			return this.screenWidth
		},
	},
	methods: {
		loc_firstSelect(val) {
			this.$store.state.searchsel_city2.items = location1[val].sort()
			this.$store.state.searchsel_city2.value = ''
			this.$store.state.searchsel_city3.value = ''
		},
		loc_twoSelect(val) {
			this.$store.state.searchsel_city3.value = ''
			this.$store.state.searchsel_city3.items = location2[this.$store.state.searchsel_city1.value][val].sort()
		},
		setRadioValue(idx) {
			this.nowRadioValue = this.$store.state.reservedayInputBox.categories[idx].value
		},
		checkboxIcon() {
			let items = this.$store.state.reservedayInputBox.categories
			let index
			if (items !== undefined) {
				index = items.findIndex(t => t.type === 11)
				if (index !== -1) {
					items.forEach(x => {
						if (x.type === 11) {
							x.items.forEach(e => {
								e.onicon = 'mdi-check-circle'
								e.officon = 'mdi-check-circle-outline'
								// e.color = this.$store.state.PointColor1
							})
						}
					})
				}
				index = items.findIndex(t => t.type === 12)
				if (index !== -1) {
					items.forEach(x => {
						if (x.type === 12) {
							x.items.color = 'black'
						}
					})
				}
			}
		},
		imgdialog(idx) {
			this.imgfile.dialog = true
			this.imgfile.img = this.$store.state.reserveusersData.fileUpload[idx]
		},
		userimgdelete(idx) {
			this.$store.state.reserveusersData.fileUpload.splice(idx, 1)
		},
		handleImages(files) {
			let fileArr = files
			let filemax
			if (!fileArr) {
				filemax = this.$store.state.reserveusersData.fileUpload.length
			} else if (!this.$store.state.reserveusersData.fileUpload) {
				filemax = fileArr.length
			} else {
				filemax = fileArr.length + this.$store.state.reserveusersData.fileUpload.length
			}

			if (filemax === 3) {
				setTimeout(() => {
					document.querySelector('.plus').style.display = 'none'
				}, 500)
			}
			if (filemax > 3) {
				fileArr.pop()
				this.alertModal.text = '이미지는 3개까지만 등록 가능합니다.'
				this.alertModal.dialog = true
			}
			this.$store.commit('filesData', fileArr)
		},
		changePicker(val) {
			this.$store.state.selectedTime = ''
			const index = this.$store.state.nodaySetting.map(x => x.date).indexOf(val)
			this.timeData.forEach(element => {
				if (index > -1) {
					if (this.$store.state.nodaySetting[index].noTime.indexOf(element.time) > -1) {
						element.disable = true
					} else {
						element.disable = false
					}
				} else {
					element.disable = false
				}
				element.active = false
			})
			// maxcount 에 따라 남은 예약 수 체크
			const date = String(`${this.$store.state.picker.date}T00:00:00.000Z`)
			// date 형식 --> 2021-06-16T00:00:00.000Z
			const data = {
				groupcode: this.$route.params.groupcode,
				code: this.$route.params.code,
				date: date,
			}
			this.$store
				.dispatch('reservedayMaxCount', data)
				.then(res => {
					let index = 0
					this.timeData.forEach(obj => {
						// let value = Object.keys(res.data.reservedayMaxCount.count[index])[0]
						let value = res.data.reservedayMaxCount.count[index][Object.keys(res.data.reservedayMaxCount.count[index])[0]]
						if (value > this.$store.state.maxcount || value === this.$store.state.maxcount) {
							obj.disable = true
						}
						index++
					})
				})
				.catch(() => {})
		},
		allowedDates(val) {
			return val
		}, // date-picker 선택 가능날짜 세팅
		timeSet() {
			if (this.$store.state.timeRange !== '') {
				let startTime = Number(this.$store.state.timeRange.split(',')[0].split(':')[0])
				let endTime = Number(this.$store.state.timeRange.split(',')[1].split(':')[0])
				let endTime2 = Number(this.$store.state.timeRange.split(',')[1].split(':')[1])
				for (startTime; startTime < endTime; startTime++) {
					this.timeData.push({ time: `${String(startTime)}:00`, active: false, disable: false })
					this.timeData.push({ time: `${String(startTime)}:30`, active: false, disable: false })
				}
				this.timeData.push({ time: `${String(endTime)}:00`, active: false, disable: false })
				if (endTime2 === 30) {
					this.timeData.push({ time: `${String(endTime)}:30`, active: false, disable: false })
				}
				this.timeData.forEach(obj => {
					if (obj.time === '8:00') {
						obj.time = '08:00'
					} else if (obj.time === '8:30') {
						obj.time = '08:30'
					} else if (obj.time === '9:00') {
						obj.time = '09:00'
					} else if (obj.time === '9:30') {
						obj.time = '09:30'
					}
				})
				this.$store.state.timeDataCopy = this.timeData
			} else {
				times.forEach(element => {
					this.timeData.push({
						time: element,
						active: false,
					})
				})
			}
		},
		clickTime(item) {
			this.$store.state.selectedTime = item.time
			// this.$store.commit('selectedTime', item.time)
			///시간 클릭
			this.timeData.forEach(element => {
				element.active = false
			})
			item.active = true
		},
		changeSelected(value) {
			let valueArray = this.$store.state.selectedValues
			let foundIndex = valueArray.findIndex(obj => {
				return obj.code === value.code
			})
			if (foundIndex === -1) {
				valueArray.push(value)
			} else {
				valueArray.splice(foundIndex)
				valueArray.push(value)
			}
			this.$store.commit('selectedValues', valueArray)
		},
	},
}
</script>

<style lang="scss">
.explain {
	margin-top: -15px;
	font-size: 12px;
	color: #003293;
}
.imgUploads {
	min-width: 250px;
	display: flex !important;
	justify-content: center !important;
	align-items: center;
	flex-wrap: nowrap !important;
	flex-direction: row !important;
	padding: 10px 50px 10px 50px;
	/* padding-top: 20px;
	padding-right: 50px;
	padding-bottom: 5px; */
	height: 95%;
}
.imgUploads2 {
	min-width: 250px;
	display: flex !important;
	justify-content: center !important;
	align-items: center;
	flex-wrap: nowrap !important;
	flex-direction: row !important;
	padding: 10px 50px 10px 50px;
	/* padding-top: 20px;
	padding-right: 50px;
	padding-bottom: 5px; */
	height: 60% !important;
}
.viewport-item {
	width: 100%;
	.v-date-picker-header__value {
		pointer-events: none;
	}
	.v-radio {
		align-items: start;
	}
	.v-input__slot {
		align-items: start;
	}
	.v-input__slot {
		align-items: end;
		.v-label {
			font-size: 15px;
		}
		.v-icon {
			font-size: 20px;
		}
	}
	.focusColor {
		.primary--text {
			color: black !important;
			caret-color: black !important;
			&.v-input,
			&.v-select,
			&.v-icon {
				color: black !important;
				caret-color: black !important;
			}
			.v-input .v-select {
				color: black !important;
				caret-color: black !important;
			}

			// &.v-tabs-bar {
			// 	color: black !important;
			// 	caret-color: black !important;
			// 	.v-tab--active {
			// 		color: black !important;

			// 		& > .icon {
			// 			color: black !important;
			// 		}
			// 	}
			// }
		}
	}

	.focusColorButton {
		.primary--text {
			&.v-input,
			&.v-icon {
				color: #fade0d !important;
				caret-color: #fade0d !important;
			}
		}
	}
	.surveyName {
		font-size: 15px;
		font-weight: 500;
		margin-bottom: 0px !important;
	}
}

.viewport-item-counselor {
	.v-select__slot {
		height: 27px !important;
	}
	.v-date-picker-header__value {
		pointer-events: none;
	}
	.v-radio {
		align-items: start;
	}
	.v-input__slot {
		align-items: start;
	}
	.v-input__slot {
		align-items: end;
		.v-label {
			font-size: 15px;
		}
		.v-icon {
			font-size: 20px;
		}
	}
	.focusColor {
		.primary--text {
			color: black !important;
			caret-color: black !important;
			&.v-input,
			&.v-select,
			&.v-icon {
				color: black !important;
				caret-color: black !important;
			}
			.v-input .v-select {
				color: black !important;
				caret-color: black !important;
			}

			// &.v-tabs-bar {
			// 	color: black !important;
			// 	caret-color: black !important;
			// 	.v-tab--active {
			// 		color: black !important;

			// 		& > .icon {
			// 			color: black !important;
			// 		}
			// 	}
			// }
		}
	}

	.focusColorButton {
		.primary--text {
			&.v-input,
			&.v-icon {
				color: #fade0d !important;
				caret-color: #fade0d !important;
			}
		}
	}
	.surveyName {
		font-size: 15px;
		font-weight: 500;
		margin-bottom: 0px !important;
	}
}
.direction-column {
	.imgsPreview {
		display: flex !important;
		justify-content: center;
		flex-direction: column !important;
	}
}
.direction-row {
	.imgsPreview {
		display: flex !important;
		align-items: center !important;
		flex-direction: row !important;
	}
}
.fileMargin {
	margin-bottom: 100px;
}
.selectedResVisit {
	font-size: 14px;
	font-weight: 500;
	margin-bottom: 0px !important;
	span {
		color: #006b8f;
	}
}
.visitexplain {
	font-size: 13px;
	color: #a2a2a2;
	white-space: break-spaces;
	cursor: pointer;
}
</style>
<style lang="scss" scoped>
.visitexplain {
	font-size: 13px;
	color: #6e6e6e;
	white-space: break-spaces;
}
.viewport-item {
	.item-style {
		width: 320px;
	}
	.item-style2 {
		// min-width: 275px;
		width: 320px;
	}
	.item-style3 {
		// min-width: 275px;
		width: 300px;
	}
	.item-style4 {
		// min-width: 275px;
		width: 270px;
	}
	padding: 10px 0px;
	// border-bottom: 0.5px dashed #e0e0e0;
}

.viewport-item-counselor {
	width: 100%;
	// .item-style {
	// 	// width: 320px;
	// }
	// .item-style2 {
	// 	// min-width: 275px;
	// 	// width: 320px;
	// }
	// .item-style3 {
	// 	// min-width: 275px;
	// 	// width: 300px;
	// }
	// .item-style4 {
	// 	// min-width: 275px;
	// 	// width: 270px;
	// }
	padding: 20px 0px 0px;
	// border-bottom: 0.5px dashed #e0e0e0;
}
.required-red-dot {
	color: #ff5252;
}
// .uploadMargin {
// 	margin-bottom: 140px;
// }
.minmax-width320 {
	min-width: 320px;
	max-width: 320px;
}
</style>
